const MENU_TITLE_KEYS = {
  Apps: 'navigation.apps',
  Marketplace: 'navigation.marketplace',
  Commerce: 'navigation.commerce',
  Listings: 'navigation.listings',
  Promotions: 'navigation.promotions',
  Marketing: 'navigation.marketing',
  Intelligence: 'navigation.intelligence',
  People: 'navigation.people',
};

export const translateMenuTitle = (menu, translate) => {
  const title = typeof menu === 'string' ? menu : menu?.title;
  const key = menu?.translation_key || MENU_TITLE_KEYS[title] || title;
  return translate(key, title);
};
